import React from 'react';

const stats = [
  { id: 1, label: 'Loan volume', name: 'SBA loans approved', value: '80,000+', note: 'Across the program in 2025', icon: '#' },
  { id: 2, label: 'Capital deployed', name: 'SBA approval volume', value: '$40B+', note: 'Approved during 2025', icon: '$' },
  { id: 3, label: 'Rate benchmark', name: 'Current WSJ prime rate', value: '6.75%', note: 'Base rate before lender spread', icon: '%' },
];

export default function StatSection() {
  return (
    <section className="bg-white py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col justify-between gap-4 border-b border-slate-200 pb-8 sm:flex-row sm:items-end">
          <div><p className="text-sm font-semibold uppercase tracking-wider text-blue-600">Market snapshot</p><h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">The SBA market, in context.</h2></div>
          <p className="max-w-md text-sm leading-6 text-slate-500 sm:text-right">Program scale and the benchmark that influences variable-rate SBA financing.</p>
        </div>
        <dl className="mt-8 grid overflow-hidden rounded-2xl border border-blue-100 bg-gradient-to-br from-blue-50/80 via-white to-white shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-blue-100">
          {stats.map((stat) => (
            <div
              key={stat.id}
              className="group relative flex min-h-[210px] flex-col justify-between border-b border-blue-100 p-6 last:border-b-0 sm:border-b-0 lg:p-8"
            >
              <div className="flex items-center justify-between">
                <span className="text-xs font-semibold uppercase tracking-[0.14em] text-blue-700">{stat.label}</span>
                <span className="flex h-9 w-9 items-center justify-center rounded-full border border-blue-200 bg-white text-sm font-bold text-blue-600 shadow-sm">{stat.icon}</span>
              </div>
              <div className="mt-8">
                <dd className="text-4xl font-bold tracking-[-0.04em] text-slate-950 lg:text-5xl">{stat.value}</dd>
                <dt className="mt-3 text-base font-semibold text-slate-800">{stat.name}</dt>
                <p className="mt-1 text-sm text-slate-500">{stat.note}</p>
              </div>
              <div className="absolute inset-x-6 bottom-0 h-0.5 origin-left scale-x-0 bg-blue-600 transition-transform duration-300 group-hover:scale-x-100 lg:inset-x-8" />
            </div>
          ))}
        </dl>
        <p className="mt-4 text-xs text-slate-400">Market figures are directional and subject to final SBA reporting. Prime rate changes over time.</p>
      </div>
    </section>
  );
}
